export default function ProBadge({ style }) {
  return (
    <span style={{
      background: "linear-gradient(145deg, #c0a060, #8a7040, #a89050)",
      color: "#f0e8d0",
      fontSize: 9,
      fontWeight: 700,
      padding: "3px 7px",
      borderRadius: 3,
      letterSpacing: 1.2,
      verticalAlign: "middle",
      textTransform: "uppercase",
      border: "1px solid rgba(200,170,100,0.3)",
      flexShrink: 0,
      ...style,
    }}>PRO</span>
  );
}
